import {
  BUTTON_SIZE,
  ButtonFill,
  ButtonGhost,
  Flex,
  Heading,
  HeadingStyles,
} from '@npco/zeller-design-system'

import { ReactComponent as CloseIcon } from 'assets/svg/close.svg'
import { useTransferState } from 'pages/Transfer/Transfer.context'
import { TransferEvent } from 'pages/Transfer/Transfer.stateMachine'
import { page, shared } from 'translations'

import {
  StyledIcon,
  StyledPaymentContent,
  StyledPaymentDescription,
  StyledPaymentWrapper,
} from './TransferError.styled'

export const TransferError = () => {
  const {
    transferState: [, send],
  } = useTransferState()
  return (
    <StyledPaymentWrapper>
      <StyledPaymentContent>
        <StyledIcon>
          <CloseIcon />
        </StyledIcon>
        <Heading.H1 withStyles={HeadingStyles.H2}>
          {page.transfer.error.headline}
        </Heading.H1>
        <StyledPaymentDescription>
          <p>{page.transfer.error.lead}</p>
          <p>{page.transfer.error.description1}</p>
        </StyledPaymentDescription>

        <Flex>
          <ButtonGhost
            size={BUTTON_SIZE.LARGE}
            onClick={() => send(TransferEvent.Back)}
          >
            {shared.close}
          </ButtonGhost>
          <ButtonFill
            size={BUTTON_SIZE.LARGE}
            onClick={() => send(TransferEvent.Continue)}
          >
            {shared.tryAgain}
          </ButtonFill>
        </Flex>
      </StyledPaymentContent>
    </StyledPaymentWrapper>
  )
}
